module.exports = __webpack_public_path__ + "static/media/montagem_ornamentos.3653373e.png";